import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { toast } from 'sonner';
import { Check } from 'lucide-react';

const TEMAS = [
  {
    id: 'masculino',
    nome: 'Masculino',
    descricao: 'Tema atual — escuro, com laranja. Ideal para construção civil, reformas e manutenção.',
    swatches: ['#18181b', '#27272a', '#f97316', '#39ff14', '#ffffff'],
  },
  {
    id: 'feminino',
    nome: 'Feminino',
    descricao: 'Claro, com rosé e dourado. Ideal para salão de beleza, estética e terapeutas.',
    swatches: ['#FAF3EF', '#FFFFFF', '#C4778F', '#B08D57', '#3E2E2E'],
  },
  {
    id: 'vinho',
    nome: 'Vinho',
    descricao: 'Escuro, com tons de vinho e rosé. Ideal para barbearias, tabacarias e adegas.',
    swatches: ['#6a2a2f', '#8f4d51', '#b57072', '#da9394', '#ffb6b6'],
  },
  {
    id: 'ciano',
    nome: 'Ciano',
    descricao: 'Claro, com tons de azul e ciano. Ideal para oficinas, pet shops e clínicas.',
    swatches: ['#f4fdff', '#adffff', '#23c2f9', '#68e1fc', '#0e2f38'],
  },
  {
    id: 'floresta',
    nome: 'Floresta',
    descricao: 'Escuro, com tons de verde. Ideal para paisagismo, jardinagem e produtos naturais.',
    swatches: ['#234d20', '#36802d', '#77ab59', '#c9df8a', '#f0f7da'],
  },
];

export default function Temas() {
  const [tema, setTema] = useState('masculino');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/settings/')
      .then(res => setTema(res.data.tema || 'masculino'))
      .catch(() => toast.error('Erro ao carregar tema atual'))
      .finally(() => setLoading(false));
  }, []);

  const salvar = async () => {
    setSaving(true);
    try {
      await api.put('/settings/', { tema });
      toast.success('Tema salvo! A mudança aparece na tela de Agenda e na página pública de agendamento.');
    } catch { toast.error('Erro ao salvar tema'); }
    finally { setSaving(false); }
  };

  if (loading) {
    return (
      <div className="flex justify-center py-16">
        <div className="w-7 h-7 border-2 border-orange-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="space-y-5 animate-fade-in">
      <div>
        <h1 className="font-heading text-2xl font-bold text-white">Temas</h1>
        <p className="text-sm text-zinc-500 mt-1">Escolha a paleta de cores usada na tela de Agenda e na página pública de agendamento do seu cliente.</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {TEMAS.map(t => (
          <button
            key={t.id}
            onClick={() => setTema(t.id)}
            className={`text-left bg-zinc-900 border rounded-xl p-5 transition-colors ${
              tema === t.id ? 'border-orange-500' : 'border-zinc-800 hover:border-zinc-700'
            }`}
          >
            <div className="flex items-center justify-between mb-3">
              <span className="font-heading font-semibold text-white">{t.nome}</span>
              {tema === t.id && (
                <span className="w-5 h-5 rounded-full bg-orange-500 flex items-center justify-center">
                  <Check size={12} className="text-white" />
                </span>
              )}
            </div>
            <div className="flex gap-1.5 mb-3">
              {t.swatches.map(cor => (
                <span key={cor} className="w-8 h-8 rounded-md border border-zinc-800" style={{ background: cor }} />
              ))}
            </div>
            <p className="text-xs text-zinc-500">{t.descricao}</p>
          </button>
        ))}
      </div>

      <button onClick={salvar} disabled={saving}
        className="bg-orange-500 hover:bg-orange-400 disabled:opacity-50 text-white font-semibold px-5 py-2.5 rounded-xl transition-colors text-sm">
        {saving ? 'Salvando...' : 'Salvar tema'}
      </button>
    </div>
  );
}
